import React from 'react';
import { Link } from 'react-router';
import logo from '../images/updated-logo.svg';
import './splash.css';
import { backgrounds } from '../services/content';
import { isApp } from '../services/config';

export default function() {
  return (
    <div 
      className={`splash ${isApp ? 'is-mobile' : ''}`}>
      
      {backgrounds.slice(0,4).map((background, i) => 
        <div 
          key={background}
          className="splash-background" 
          style={{
            backgroundImage: `url(${background})`,
          }}
        />
      )}
      
      <div className="splash-background-overlay"/>
      
      <img src={logo} className="splash-logo" alt="Stanford Cancer Institute"/>
      
      <div className="splash-title">Cancer Clinical Trials</div>
      
      <Link to="/language" className="splash-bottom">
        <div className="splash-language">
          <div>Toque para iniciar</div>
          <div>觸摸開始</div>
          <div>ВХОД</div>
        </div>
        <div className="splash-touch">Touch to Begin</div>
      </Link>
      
      <div className="splash-nav" onClick={e => e.stopPropagation()}>
        <Link to="/find" className="splash-nav-link">Find Clinical Trials</Link>
        <Link to="/contact" className="splash-nav-link">Contact Us</Link>
      </div>
      
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/Splash.js